import { SHELL_ID } from "@aviv-unified-frontend/internal";
import { useLocale, useTranslation } from "@aviv-unified-frontend/runtime/i18n";
import { useMemo, useRef } from "react";
/**
 * Hook to load the translations for the current brand and language.
 */
export const useLoadTranslations = () => {
    const { language } = useLocale();
    const { addTranslations } = useTranslation(SHELL_ID);
    const removeTranslations = useRef(() => { });
    removeTranslations.current = useMemo(() => {
        removeTranslations.current();
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const translations = require(`../translations/${language}.json`);
        return addTranslations({
            language,
            translations,
        });
    }, [addTranslations, language]);
};
